import { useToast } from 'components/ToastManager';
import { useHasWorkspacePermission } from 'hooks/useHasWorkspacePermission';
import { useInternalApiContext } from 'hooks/useInternalApiContext';
import React from 'react';
import { useWorkspaceId } from 'wrappers/WorkspaceProvider';

import { Permissions } from '@fragment/authorization-utils/permissions';
import { Toast } from '@fragment/ui/src/components/Toast/Toast';

import { PaymentAccountSettingsList } from './PaymentAccountSettingsList';
import { SettingsModalLayout } from './SettingsModalLayout';

export const PaymentAccountsSettingsForm = () => {
  const workspaceId = useWorkspaceId();
  const { context } = useInternalApiContext();
  const canVerify = useHasWorkspacePermission(
    Permissions.payment_account.verify
  );
  const { showToast } = useToast();
  return (
    <SettingsModalLayout title="Payment accounts">
      <PaymentAccountSettingsList
        workspaceId={workspaceId}
        context={context}
        hasAccessToken={Boolean(context.token)}
        canVerify={canVerify}
        onError={(message) =>
          showToast(<Toast type="error" message={message} />)
        }
      />
    </SettingsModalLayout>
  );
};
